module.exports = __webpack_public_path__ + "img/hole-2.c9ad4496.png";